<template>
  <modal class="timeout-modal" :closeBtn="allowClose">
    <template v-slot:header> </template>
    <p class="error">
      Please refresh and select your information again to save your changes.
    </p>
    <template v-slot:footer>
      <div class="footer-btns">
        <!-- <button
          type="button"
          class="btn btn-secondary"
          @click.prevent="$emit('refresh')">
          Refresh
        </button> -->
      </div>
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Modal from "../shared/Modal.vue";

export default defineComponent({
  components: {
    Modal,
  },
  data: () => ({
    allowClose: false,
  }),
});
</script>

<style>
.timeout-modal .modal-wrapper .modal-container .modal-body {
  min-height: 100px;
  padding: 1.563rem 1.5rem;
}

.timeout-modal .modal-container {
  max-width: 400px;
}
</style>

<style scoped>
.footer-btns button {
  margin-left: 15px;
}
</style>
